<template>
  <div>
<!--    <FilterOption class="mb-4"/>-->
<!--    <CRow>-->
<!--      <CCol col="7">-->
<!--&lt;!&ndash;        <CInput label="Search" type="text" class="mb-0"/>&ndash;&gt;-->
<!--      </CCol>-->
<!--      <CCol>-->
<!--        <CInput label="Start Date" type="datetime-local" class="mb-0"/>-->
<!--      </CCol>-->
<!--      <CCol>-->
<!--        <CInput label="End Date" type="datetime-local"/>-->
<!--      </CCol>-->
<!--    </CRow>-->

    <History caption="Accounts" icon="cil-user" :item="accounts"/>
  </div>
</template>

<script>


import {mapGetters} from 'vuex'
import History from "@/projects/views/E-Port/users/components/Historys";
import FilterOption from "@/projects/views/E-Port/users/components/FilterOptionMembers";
export default {
  name: 'index',
  components: {FilterOption, History},
  props:{
    caption:{
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      mapping : {
        type : "",
        item : {}
      },

      dialog:true,
      accounts:[]


    }


  },

  mounted () {
  },

  created () {
    this.onInit()

  },
  beforeDestroy () {

  },

  methods: {
    onInit(){
      this.onLoad();
    },

    onLoad(){
      var data = {};
      this.$store.dispatch("member/config", data)
    }
  },



  computed:{
    ...mapGetters({
      objsLang : "setting/lang",
      objsMember : "member/members",
    }),
  },

  watch: {

    objsMember: function (value) {
      this.accounts = [];
      var lang = this.$store.getters['setting/lang']
      var items = [];
      value.filter(item => {
        var objs = {};
        try {
          objs.code = item.accounts.authen.filter(item => { return (item.username != null ) })[0].username
        }catch (e) {

        }
        objs.info = item.accounts.userinfo.prefix.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value +" "+item.accounts.userinfo.lastName.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value+" "+ item.accounts.userinfo.firstName.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value;
        objs.affiliation = item.affiliation.title.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value
        objs.position = item.position.title.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value
        objs.value = item;

        items.push(objs)
      })
      this.accounts = items;

    }
  }

}
</script>
<style >


</style>
